import AbstractCallerIds from '@Containers/UserCallerIds/AbstractCallerIds';
import { VoiceProvider } from '@Models/callerIds.models';

const TwilioCallerIds = (): JSX.Element => (
  <AbstractCallerIds provider={VoiceProvider.TWILIO} />
);

export default TwilioCallerIds;
